import { useRouter } from 'next/router';
import { useState } from 'react';
// Components
import NavLink from '../NavLink/NavLink';
// Styles & Icons
import { useAuth } from '@/hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './navGroup.module.css';

const NavGroup = ({ value, icon, childRoutes, close, setIsDrawerOpen }) => {
  const { asPath } = useRouter();
  const { userHasPermissions } = useAuth();

  const [groupVisible] = useState(true);

  if (!groupVisible) return null;

  return (
    <>
      <div className={`${styles.wrapper}`}>
        <FontAwesomeIcon
          icon={icon}
          width={16}
          style={{ marginRight: 16, width: '14px', height: '14px' }}
        />
        <div className={styles.labelWrapper}>
          <p>{value}</p>
        </div>
      </div>
      <div className={styles.linksWrapper}>
        {Object.values(childRoutes).map((route, index) => (
          <NavLink
            isSub
            close={close}
            key={route?.value + '+' + index}
            {...route}
            locked={!userHasPermissions(route?.permission) && !asPath.includes('/docs')}
            setIsDrawerOpen={setIsDrawerOpen}
          />
        ))}
      </div>
    </>
  );
};

export default NavGroup;
